<template>
    <MainLayout>
        <LoaderPage v-if="loadingPage" />
        <div :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-sticky tw-top-0 tw-z-10">
            <div class="tw-mx-auto tw-px-6 tw-py-4 md:tw-flex md:tw-justify-between tw-items-center">
                <div>
                    <h1 :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-slate-800'" class="tw-text-2xl tw-font-bold">Leituras Automáticas</h1>
                    <p :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-sm tw-mt-1">Por padrão, o sistema realiza duas leituras diárias, uma às 4h e outra às 16h</p>
                </div>
                <div class="tw-flex tw-items-center tw-gap-4 sm:tw-m-top-4">
                    <span v-if="!permissaoEditar" :class="theme === 'dark' ? 'tw-bg-amber-500/10 tw-text-amber-400 tw-border-amber-500/20' : 'tw-bg-amber-50 tw-text-amber-700 tw-border-amber-200'" class="tw-px-4 tw-py-1.5 tw-rounded-full tw-border">
                        Modo Visualização
                    </span>
                </div>
            </div>
        </div>

        <main :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-mx-auto tw-p-6">
            <div class="tw-max-w-5xl tw-mx-auto">
                <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6 tw-items-start">
                    <section :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-rounded-2xl tw-p-6 tw-shadow-sm">
                        <div class="tw-flex tw-items-center tw-gap-3 tw-mb-6">
                            <div class="tw-p-2.5 tw-rounded-xl" :class="theme === 'dark' ? 'tw-bg-emerald-500/10 tw-text-emerald-400' : 'tw-bg-emerald-50 tw-text-emerald-600'">
                                <svg class="tw-w-6 tw-h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/></svg>
                            </div>
                            <div>
                                <h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold">Cadastrar Horário</h3>
                            </div>
                        </div>

                        <div class="tw-space-y-4">
                            <h4 :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-text-sm tw-font-bold tw-uppercase tw-tracking-wider">Adicionar novo horário</h4>
                            <div :class="theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-white'" class="tw-flex tw-items-center tw-gap-3 tw-p-4 tw-rounded-xl tw-shadow-sm">
                                <template v-if="isTermocloud">
                                    <select
                                        v-model="novaHora"
                                        :disabled="!permissaoEditar"
                                        :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-gray-300 tw-text-black'"
                                        class="tw-w-20 tw-rounded-xl tw-p-3 tw-text-sm focus:tw-ring-2 focus:tw-ring-emerald-500 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                                    >
                                        <option value="" disabled>Hora</option>
                                        <option v-for="h in HORAS" :key="h" :value="h">{{ h }}</option>
                                    </select>
                                    <span :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-font-bold">:</span>
                                    <select
                                        v-model="novoMinuto"
                                        :disabled="!permissaoEditar"
                                        :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-gray-300 tw-text-black'"
                                        class="tw-w-20 tw-rounded-xl tw-p-3 tw-text-sm focus:tw-ring-2 focus:tw-ring-emerald-500 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                                    >
                                        <option value="" disabled>Min</option>
                                        <option v-for="m in MINUTOS" :key="m" :value="m">{{ m }}</option>
                                    </select>
                                </template>
                                <input
                                    v-else
                                    type="time"
                                    v-model="novoHorario"
                                    :disabled="!permissaoEditar"
                                    :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-gray-300 tw-text-black'"
                                    class="tw-flex-1 tw-rounded-xl tw-p-3 tw-text-sm focus:tw-ring-2 focus:tw-ring-emerald-500 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                                >
                                <button
                                    @click="adicionarHorario()"
                                    :disabled="!permissaoEditar"
                                    :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-slate-300 hover:tw-bg-slate-700' : 'tw-bg-gray-300 tw-text-slate-700 hover:tw-bg-gray-300'"
                                    class="tw-px-6 tw-py-2 tw-text-sm tw-font-semibold tw-rounded-xl disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                                >
                                    Adicionar
                                </button>
                            </div>
                        </div>

                        <hr :class="theme === 'dark' ? 'tw-border-slate-700' : 'tw-border-slate-200'" class="tw-my-6" />

                        <div v-if="permissaoEditar" class="tw-flex tw-gap-3 tw-justify-end">
                            <button
                                @click="resetHorarios"
                                :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-slate-300 hover:tw-bg-slate-700' : 'tw-bg-gray-200 tw-text-slate-700 hover:tw-bg-gray-300'"
                                class="tw-px-5 tw-py-2 tw-text-sm tw-font-semibold tw-rounded-xl"
                            >
                                Descartar
                            </button>
                            <button
                                @click="salvarHorarios"
                                :disabled="salvandoLoading"
                                :class="theme === 'dark' ? 'tw-bg-emerald-500 hover:tw-bg-emerald-600 focus:tw-ring-emerald-500/20' : 'tw-bg-emerald-600 hover:tw-bg-emerald-700 focus:tw-ring-emerald-100'"
                                class="tw-px-6 tw-py-2.5 tw-text-white tw-text-sm tw-font-bold tw-rounded-xl tw-shadow-sm focus:tw-ring-4 disabled:tw-opacity-50"
                            >
                                <span v-if="!salvandoLoading">Salvar Horários</span>
                                <span v-else>Processando...</span>
                            </button>
                        </div>
                    </section>

                    <section :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-rounded-2xl tw-p-6 tw-shadow-sm">
                        <div class="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-mb-8">
                            <div class="tw-flex tw-items-center tw-gap-3">
                                <div class="tw-p-2.5 tw-rounded-xl" :class="theme === 'dark' ? 'tw-bg-emerald-500/10 tw-text-emerald-400' : 'tw-bg-emerald-50 tw-text-emerald-600'">
                                    <svg class="tw-w-6 tw-h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
                                </div>
                                <div>
                                    <h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold">Horários Cadastrados</h3>
                                </div>
                            </div>

                            <div v-if="permissaoEditar && horarios.length" class="tw-flex tw-items-center tw-gap-2">
                                <button
                                    v-if="!modoRemocao"
                                    @click="toggleModoRemocao"
                                    :class="theme === 'dark' ? 'tw-text-red-400 hover:tw-bg-red-500/10' : 'tw-text-red-600 hover:tw-bg-red-50'"
                                    class="tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-rounded-lg"
                                >
                                    <svg class="tw-w-4 tw-h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>
                                    Remover leituras
                                </button>
                                <template v-else>
                                    <button
                                        @click="toggleModoRemocao"
                                        :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-slate-300 hover:tw-bg-slate-700' : 'tw-bg-gray-200 tw-text-slate-700 hover:tw-bg-gray-300'"
                                        class="tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-rounded-lg"
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        @click="removerSelecionados"
                                        :disabled="!selecionados.length"
                                        class="tw-px-3 tw-py-1.5 tw-text-xs tw-font-bold tw-rounded-lg tw-text-white tw-bg-red-600 hover:tw-bg-red-700 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                                    >
                                        Excluir ({{ selecionados.length }})
                                    </button>
                                </template>
                            </div>
                        </div>

                        <div v-if="horarios.length === 0" :class="theme === 'dark' ? 'tw-bg-[#1a1d21] tw-text-slate-400' : 'tw-bg-slate-50 tw-text-slate-500'" class="tw-p-6 tw-rounded-xl tw-text-center tw-text-sm">
                            Nenhum horário configurado
                        </div>
                        <div v-else class="tw-flex tw-flex-col tw-gap-2 tw-max-h-96 tw-overflow-y-auto custom-scrollbar tw-pr-1">
                            <div
                                v-for="horario in horariosOrdenados"
                                :key="horario.id"
                                @click="modoRemocao && toggleSelecionado(horario.id)"
                                :class="[
                                    'tw-flex tw-items-center tw-justify-between tw-py-2 tw-px-3 tw-rounded-lg tw-transition-colors',
                                    modoRemocao ? 'tw-cursor-pointer' : '',
                                    theme === 'dark'
                                        ? (selecionados.includes(horario.id) ? 'tw-bg-red-500/20 tw-ring-1 tw-ring-red-500/40' : 'tw-bg-[#1a1d21]')
                                        : (selecionados.includes(horario.id) ? 'tw-bg-red-100 tw-ring-1 tw-ring-red-300' : 'tw-bg-slate-100')
                                ]"
                            >
                                <div class="tw-flex tw-items-center tw-gap-2">
                                    <input
                                        v-if="modoRemocao"
                                        type="checkbox"
                                        :checked="selecionados.includes(horario.id)"
                                        class="tw-pointer-events-none tw-w-4 tw-h-4 tw-accent-red-500"
                                    >
                                    <span :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-font-medium tw-text-sm">{{ horario.horario.substring(0, 5) }}</span>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </main>
    </MainLayout>
</template>

<script>
import MainLayout from '@/components/layouts/v2/MainLayout.vue';
import LoaderPage from '@/components/ui/v2/LoaderPage.vue';
import { useToast } from 'vue-toastification';
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import { mapState } from 'vuex';

export default {
    components: {
        MainLayout,
        LoaderPage
    },

    setup() {
        const store = useStore();
        const toast = useToast();
        const loadingPage = ref(true);
        const route = useRoute();
        const horarios = ref([]);
        const horariosBackup = ref([]);
        const novaHora = ref('');
        const novoMinuto = ref('');
        const novoHorario = ref('');
        const permissaoEditar = ref(false);
        const salvandoLoading = ref(false);
        const modoRemocao = ref(false);
        const selecionados = ref([]);

        const HORAS = Array.from({ length: 24 }, (_, h) => String(h).padStart(2, '0'));
        const MINUTOS = ['00', '30'];

        const horariosOrdenados = computed(() =>
            [...horarios.value].sort((a, b) => a.horario.localeCompare(b.horario))
        );

        const isTermocloud = computed(() =>
            String(store.state.unidade.unidade?.tipo_produto || '').toLowerCase() === 'termocloud'
        );

        onMounted(async () => {
            loadingPage.value = true;
            const unidadeId = route.params.unidade;
            permissaoEditar.value = store.state.unidade.unidade.permissoes?.alteracao_leitura_automatica || false;

            try {
                const response = await store.dispatch("leituras/getLeiturasAutomaticas", unidadeId);
                horarios.value = response;
                horariosBackup.value = structuredClone(response);

            } catch (error) {
                console.error("Erro ao buscar leituras:", error);
                toast.error("Erro ao buscar leituras");
            }
            loadingPage.value = false;
        });

        const adicionarHorario = async () => {
            let horarioStr;
            if (isTermocloud.value) {
                if (novaHora.value === '' || novoMinuto.value === '') {
                    toast.warning("Selecione a hora e o minuto");
                    return;
                }
                horarioStr = `${novaHora.value}:${novoMinuto.value}`;
            } else {
                if (!novoHorario.value) {
                    toast.warning("Por favor, insira um horário válido");
                    return;
                }
                horarioStr = novoHorario.value;
            }

            if (horarios.value.some(h => h.horario.substring(0, 5) === horarioStr)) {
                toast.warning("Este horário já está cadastrado");
                return;
            }

            try {
                horarios.value.push({
                    id: Date.now(),
                    unidade_id: route.params.unidade,
                    horario: horarioStr + ":00",
                    status: 1,
                    created_at: new Date().toISOString(),
                    updated_at: new Date().toISOString()
                });
                novaHora.value = '';
                novoMinuto.value = '';
                novoHorario.value = '';
                toast.info("Horário adicionado, clique em [Salvar Horários] para manter as alterações");
            } catch (error) {
                console.error("Erro ao adicionar horário:", error);
                toast.error("Erro ao adicionar horário");
            }
        };

        const resetHorarios = () => {
            horarios.value = structuredClone(horariosBackup.value);
            modoRemocao.value = false;
            selecionados.value = [];
            toast.info("Alterações canceladas");
        };

        const toggleModoRemocao = () => {
            modoRemocao.value = !modoRemocao.value;
            selecionados.value = [];
        };

        const toggleSelecionado = (id) => {
            const idx = selecionados.value.indexOf(id);
            if (idx === -1) {
                selecionados.value.push(id);
            } else {
                selecionados.value.splice(idx, 1);
            }
        };

        const removerSelecionados = () => {
            if (selecionados.value.length === 0) {
                toast.warning("Selecione ao menos um horário");
                return;
            }
            horarios.value = horarios.value.filter(h => !selecionados.value.includes(h.id));
            modoRemocao.value = false;
            selecionados.value = [];
            toast.info("Horários removidos, clique em [Salvar Horários] para manter as alterações");
        };

        const salvarHorarios = async () => {
            salvandoLoading.value = true;
            const horariosASalvar = horarios.value.map(horario => ({
                horario: horario.horario.substring(0, 5),
                status: horario.status
            }));
            try {
                const unidadeId = route.params.unidade;
                let response = await store.dispatch("leituras/salvarLeiturasAutomaticas", { unidadeId, horariosASalvar });
                horariosBackup.value = structuredClone(horarios.value);

                const tipoProduto = String(store.state.unidade.unidade?.tipo_produto || '').toLowerCase();
                if (tipoProduto === 'termocloud') {
                    toast.success("Horários atualizados com sucesso.");
                } else {
                    toast.info("Dados enviados ao Painel TermoWeb, aguardando confirmação...", { timeout: 3900 });
                    let messageId = response.data.message.message_id;
                    setTimeout(async () => {
                        let msg = await store.dispatch("message/fetchMessage", messageId);
                        if (msg.status != 'processed') {
                            toast.error("Atualização nos horários não processada pelo Painel TermoWeb.");
                        } else {
                            toast.success("Horários atualizados com sucesso.");
                        }
                    }, 4000);
                }
            } catch (error) {
                console.error("Erro ao salvar horários:", error);
                toast.error("Erro ao salvar horários");
            }
            salvandoLoading.value = false;
        };

        return {
            loadingPage,
            horarios,
            horariosOrdenados,
            novaHora,
            novoMinuto,
            novoHorario,
            HORAS,
            MINUTOS,
            isTermocloud,
            modoRemocao,
            selecionados,
            toggleModoRemocao,
            toggleSelecionado,
            removerSelecionados,
            adicionarHorario,
            permissaoEditar,
            resetHorarios,
            salvarHorarios,
            salvandoLoading
        }
    },

    computed: {
        ...mapState({
            theme: state => state.ui.theme,
        }),
    }
}
</script>